import type { ColumnDefinition } from "@frui.ts/dataviews/dist/dataTypes";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import type AccountingDocumentsInventoryResponse from "entities/accountingDocumentsInventoryResponse";
import { observer } from "mobx-react-lite";
import { formatDateTime } from "utils/localizations";
import DocumentsInventoryFilters from "./components/documentsInventoryFilters";
import DocumentsInventoryMenu from "./components/documentsInventoryMenu";
import DocumentsInventoryViewModel from "../../../../viewModels/finance/accountingInventory/documentsInventory/documentsInventoryViewModel";
import ListView from "../../../common/list";

export const DocumentsInventoryView: ViewComponent<DocumentsInventoryViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<AccountingDocumentsInventoryResponse>[] = [
    {
      title: vm.translateAttribute("accountingPeriodMonthRangeSimple"),
      property: "accountingPeriodMonthRange",
      valueFormatter: props => {
        const formatPeriod = (value: string) => {
          const [year, month] = value.split("-");
          return `${month}/${year}`;
        };
        return `${formatPeriod(props.value.from)} - ${formatPeriod(props.value.to)}`;
      },
    },
    {
      title: vm.translateAttribute("status"),
      property: "status",
      valueFormatter: props => {
        const textClass = vm.getStatusTextClass(props.value, props.item.checkResult);
        const style = textClass === "text-dark-blue" ? { color: "#052856" } : {};

        return (
          <span className={`${textClass === "text-dark-blue" ? "" : textClass} font-weight-bold`} style={style}>
            {vm.translateStatus(props.value)}
          </span>
        );
      },
    },
    {
      title: vm.translateAttribute("checkResult"),
      property: "checkResult",
      valueFormatter: props =>
        props.value ? (
          <span className={`${vm.getCheckResultTextClass(props.value, props.item.status)} font-weight-bold`}>
            {vm.translateCheckResult(props.value)}
          </span>
        ) : (
          ""
        ),
    },
    {
      title: vm.translateAttribute("updatedAt"),
      cellClassName: "text-left",
      headerClassName: "text-left",
      valueFormatter: props => formatDateTime(props.value),

      property: "updatedAt",
    },
    {
      title: vm.translateAttribute("updatedBy"),
      property: "updatedBy",
    },
    {
      cellClassName: "text-align-end",
      headerClassName: "py-4 text-wrap align-middle",
      valueFormatter: props => <DocumentsInventoryMenu vm={vm} inventory={props.item} />,
    },
  ];

  return (
    <div className="test">
      <ListView
        vm={vm}
        classNames="min-vh-50"
        columns={columns}
        disabledAddButton={!!vm.permittedActions?.inventoryCreation?.rejectionReason}
        disabledAddButtonTooltip={vm.translate("disabledAddButtonTooltip")}
        aboveTable={<DocumentsInventoryFilters vm={vm} />}
      />
    </div>
  );
});

registerView(DocumentsInventoryView, DocumentsInventoryViewModel);
